// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5141":"1c29d9d7913ab115","41318":"51207688cc17c2a5"}[chunkId] + ".css";
};